import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';

const Index = () => import('./Index.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/system-logs'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'system_logs_index',
          meta: {
            permissions: ['administrator', 'system_logs_view'],
          },
          component: Index,
        },
      ],
    },
  ],
};
